"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvedStartHole = resolvedStartHole;
/**
 * Round-level starting hole from event config (default 1).
 * Use for non-shotgun, non-split-tee assignment paths; clamp at call sites that persist to DB.
 */
function resolvedStartHole(round) {
    const n = Number(round?.startHole);
    return Number.isFinite(n) && n > 0 ? Math.round(n) : 1;
}
